import { APP_TYPE, URL_APP_TYPE } from 'consts';
const changeHref = (prefix) => (elem) => {
    if (typeof elem.getAttribute('href') !== 'string') {
        return;
    }
    elem.setAttribute('href', elem.getAttribute('href').replace('cx-favicon', `${prefix}-favicon`));
};
const resolveFavicons = (appName) => {
    const SELECTOR = '[href*="cx-favicon"]';
    switch (appName) {
        case APP_TYPE.FLS:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.FLS]));
            break;
        case APP_TYPE.LOGIQUANTA:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.LOGIQUANTA]));
            break;
        case APP_TYPE.CUSTOMER_PORTAL:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.CUSTOMER_PORTAL]));
            break;
        case APP_TYPE.HX:
        case APP_TYPE.FSDF:
        case APP_TYPE.SF:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.HX]));
            break;
        case APP_TYPE.INTEGRA:
        case APP_TYPE.LENDER_PORTAL:
        case APP_TYPE.TEG:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.TEG]));
            break;
        case APP_TYPE.CXNA_CARRIER:
        case APP_TYPE.CXNA_BROKER:
            document.querySelectorAll(SELECTOR).forEach(changeHref(URL_APP_TYPE[APP_TYPE.CXNA_CARRIER]));
            break;
        default:
            return;
    }
};
export default resolveFavicons;
